export default function slugify(text: string ) {
    return text
        .toLowerCase()
        .normalize('NFD') // Normaliza a string para a forma de decomposição canônica Unicode, separando os acentos dos caracteres
        .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
        .replace(/[^a-z0-9 -]/g, '') // Remove todos os caracteres não alfanuméricos exceto hifens e espaços
        .replace(/\s+/g, '-') // Substitui espaços por hifens
        .replace(/-+/g, '-'); // Substitui múltiplos hifens seguidos por um único hifen
}
